export const SET_AMPLITUDE_TEST_PROPS = 'SET_AMPLITUDE_TEST_PROPS';
export const SET_TEST_VARIANT = 'SET_TEST_VARIANT';
export const SET_VARIANT_OVERRIDE = 'SET_VARIANT_OVERRIDE';
export const CLEAR_VARIANT_OVERRIDE = 'CLEAR_VARIANT_OVERRIDE';
